<template>
    <div class="row">
        <modal-x :show="showEdit" @onclose="showEdit = false" :content-style="{ 'max-width': '800px' }">
            <div style="width:100%;height:80%;margin:0 auto;overflow-y:auto;border:2px solid #ddd;background:white;">
                <div style="text-align:left;">
                    <div class="col-xs-12">
                        <h3>Add for: <span v-if="catSelected !== null"> {{ catSelected.child.name }} </span></h3>
                    </div>
                    <div class="col-xs-12 agx-col-head">Label</div>
                    <div class="col-xs-12 agx-col-msg">
                        <select v-model="label" class="form-control">
                            <option value="">Please Select</option>
                            <option value="_whatsapp">WhatsApp</option>
                            <option value="_wechat">Wechat</option>
                            <option value="_address">Address</option>
                            <option value="_banner">Banner</option>
                            <option value="_promo">Promo</option>
                            <option value="_phone">Phone</option>
                            <option value="_news">News</option>
                            <option value="_theme">Theme</option>
                            <option value="_apps">Apps</option>
                            <option value="_shopimgs">Shop Imgs</option>
                            <option value="_lang">Frontend Lang</option>
                            <option value="_lang_backend">Backend Lang</option>
                            <option value="_pagedinfos">Paged Infos</option>
                            <option value="_layout">Layout</option>
                            <option value="_laws">Laws</option>
                            <option value="_landing">Landing</option>
                            <option value="_permit">Permit</option>
                            <option value="_validator">Validator</option>
                        </select>
                    </div>
                </div>
                <br />
                <div class="col-xs-12" style="text-align:right;">
                    <input type="button" value="Create New" class="btn btn-primary" @click="addConfigLabel" />
                </div>
            </div>
        </modal-x>
        <div class="col-xs-12"
            style="margin-top:4px;padding-top:2px;padding-bottom: 20px;outline: none;border-color: #9ecaed;box-shadow: 0 0 10px #9ecaed;">
            <div class="col-xs-12" style="min-height:200px;overflow-y:auto;">
                <div class="col-xs-12">
                    <category :user-id="userId" :cat-node="catNode" @catSelected="onCatChange" cat-type="shopInfo" :view-mode="{}" :show-create-node="showCreateNode"
                        :expandAll="true"></category>
                </div>
            </div>
        </div>

        <div class="col-xs-12" style="text-align: center;">
            <div v-for="item in dataList">
                <div style="width:100%;" v-if="item.childs.length > 0">
                    <div style="font-weight:bolder;background: gray;color:white;">{{ item.parent.name }}</div>
                    <div>
                        <span v-for="cItem in item.childs" class="btn btn-default" style="margin:1px;padding:0 0;">
                            {{ cItem.child.name }}:{{ cItem.label.label }} <span class="btn btn-warning"
                                @click="removePostProp(item.parent, cItem)">X</span>
                        </span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import imageList from './imageList.vue';
import category from './category.vue';
import apis from '../api/extApi.js';
import modalX from '../components/base/ModalX1.vue';

export default {
    components: {
        modalX: modalX,
        category: category,
        imageList: imageList,
        modalX: modalX
    },
    props: {
        "userId": { type: String, default: null }
    },
    data: function () {
        return {
            showEdit: false,
            catSelected: null,
            label: null,
            catCodes: apis.api.settings.catCodes,
            apiClient: apis.api,
            catNode: null,
            showCreateNode:false,
            catConfigs: [],
            dataList: []
        };
    },
    methods: {
        addConfigLabel() {
            if (this.label === null || this.label === "") return;
            var newLabel = { catId: this.catSelected.child.catId, label: this.label };
            this.apiClient.addCatConfigLabelPrms(newLabel).done((ret) => {
                console.log('ret', ret);
                this.loadCategory();
                this.showEdit=false;
            });
        },
        onCatChange(ret) {
            this.catSelected = ret;
            console.log('onCatChange', ret);
            this.showEdit = true;
        },
        loadCategory() {
            this.apiClient.getCategoryNodePrms(this.catCodes.shopInfo, this.userId).done((catNode) => {
                console.log('catNode is', catNode);
                this.catNode = catNode;
                this.showCreateNode = catNode === null;
            });

            this.apiClient.getCatConfigLabelsPrms(this.catCodes.shopInfo).done((catConfigs) => {
                console.log("catConfigs", catConfigs);
                this.catConfigs = catConfigs;
                catConfigs.forEach((conf) => {
                    //this.add(conf.parent,conf.child);
                    this.add(conf.parent, conf);
                });
            });
        },
        add(prop, propVal) {
            if (this.checkExist(prop, propVal, this.dataList)) return;
            var _currentPropRef = this.setParentProp(prop, this.dataList);
            _currentPropRef.childs.push(propVal);
        },
        removePostProp(propObj, propVal) {
            var matched = this.getMatchedPropInternal(propObj, this.dataList);
            if (matched) {
                console.log('removing catConfig:',propVal);
                var index = matched.childs.indexOf(propVal);
                this.apiClient.removeCatConfigLabelPrms(propVal.label).done((ret) => {
                    console.log('removeCatConfigLabelPrms',ret);
                    if (ret === true) {
                        matched.childs.splice(index, 1);
                    }
                });
            }
        },
        checkExist(propObj, valObj, list) {
            var prop = this.getMatchedPropInternal(propObj, list);
            if (!prop) return false;
            var propVal = this.getMatched(valObj, prop.childs, this.propValComparer);
            if (propVal) return true;
            return false;
        },
        getMatched(target, list, comparer) {
            var matched = null;
            list.forEach((item) => {
                if (comparer) {
                    var ret = comparer(target, item);
                    if (ret === true) {
                        matched = item;
                        return;
                    }
                }
            });
            return matched;
        },
        setParentProp(propObj, list) {
            var matched = this.getMatchedPropInternal(propObj, list);
            if (matched) return matched;
            var datum = { parent: propObj, childs: [] };
            //this.dataList.push(datum);
            list.push(datum);
            return datum;
        },
        getMatchedPropInternal(propObj, propArr) {
            var matched = null;
            propArr.forEach((item) => {
                var _propComparer = this.propComparer;
                if (_propComparer) {
                    var ret = _propComparer(propObj, item.parent);
                    if (ret === true) {
                        matched = item;
                        return;
                    }
                }
            });
            return matched;
        },
        propComparer(item0, item1) {
            return item0.catId === item1.catId;
        },
        propValComparer(item0, item1) {
            return item0.child.catId === item1.child.catId;
        }
    },
    created: function () {

    },
    mounted: function () {
        this.loadCategory();
    },
    destroyed: function () {

    }
}
</script>